<template>
  <div class="column is-one-third-desktop is-half-tablet">
    <div class="box has-text-centered">
      <div class="columns" style="margin-bottom: 0">
        <div class="column has-text-left">
          {{ moment(feedback.createdAt).format("DD/MM/YY HH:mm:ss") }}
          <br />
          <b>{{ feedback.store.storeInfo.name }}</b>
        </div>

        <div class="column is-narrow">
          <b-button
            class="button is-pulled-right"
            :class="
              feedback.status === 'new' || feedback.status === undefined
                ? 'is-primary'
                : feedback.status === 'pending'
                ? 'is-warning'
                : feedback.status === 'resolved'
                ? 'is-success'
                : 'is-light'
            "
            slot="trigger"
            @click.stop
          >
            {{
              feedback.status === "new" || feedback.status === undefined
                ? "Novo"
                : feedback.status === "pending"
                ? "Pendente"
                : feedback.status === "resolved"
                ? "Resolvido"
                : "?"
            }}
          </b-button>
        </div>
      </div>

      <hr class="has-background-primary" style="margin-top: 0" />

      <div
        v-if="
          feedback.user &&
          feedback.user.personalInfo &&
          (feedback.user.personalInfo.email ||
            feedback.user.personalInfo.cellphone)
        "
      >
        <p>
          {{
            `${feedback.user.personalInfo.name} ${feedback.user.personalInfo.surname}`
          }}
        </p>

        <p v-if="feedback.user.personalInfo.email">
          {{ feedback.user.personalInfo.email }}
        </p>

        <p v-if="feedback.user.personalInfo.cellphone">
          {{ feedback.user.personalInfo.cellphone }}
        </p>
      </div>

      <p v-if="feedback.user">
        {{ feedback.user._id }}
      </p>

      <star-rating
        v-if="feedback.rating"
        :rating="feedback.rating"
        :show-rating="false"
        :star-size="40"
        :inline="true"
        :read-only="true"
      />

      <div v-if="feedback.message" class="message box has-background-light">
        {{ feedback.message }}
      </div>
    </div>
  </div>
</template>

<script>
import { mask } from "../../mixins/mask";
import starRating from "vue-star-rating";

export default {
  props: ["feedback"],

  mixins: [mask],

  components: {
    starRating
  }
};
</script>

<style scoped>
.message {
  margin-top: 1rem;
}
</style>
